// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2goac","name":"Header_name__3zcs7","birthday":"Header_birthday__35YUQ","skeleton":"Header_skeleton__35-oL"};